'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];


//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/modals/~/focus-lock/dist/utils/tabbables.js
// module id = 1102
// module chunks = 0